module.exports = __webpack_public_path__ + "static/img/writingjapaneseanimal_6_optimized.0ba79fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wja/page/writingjapaneseanimal_6_optimized.jpg
// module id = lG2T
// module chunks = 0